/* ============================================
   SHINING COACHING — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── HEADER SCROLL ──────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    // On product pages header is always solid — no scroll toggle needed
    if (document.body.classList.contains('header-solid')) {
      header.classList.add('scrolled');
    } else {
      const onScroll = () => {
        header.classList.toggle('scrolled', window.scrollY > 80);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  // ── MOBILE MENU ────────────────────────────
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav  = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  // ── SCROLL REVEAL ──────────────────────────
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(el => observer.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  // ── SCROLL TO TOP ──────────────────────────
  const scrollTopBtn = document.getElementById('scrollTop');
  if (scrollTopBtn) {
    window.addEventListener('scroll', () => {
      scrollTopBtn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });

    scrollTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── CART DRAWER ────────────────────────────
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartDrawer  = document.querySelector('.cart-drawer');
  const cartClose   = document.querySelector('.cart-drawer__close');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');

  function openCart() {
    if (cartOverlay && cartDrawer) {
      cartOverlay.classList.add('active');
      cartDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }
  }

  function closeCart() {
    if (cartOverlay && cartDrawer) {
      cartOverlay.classList.remove('active');
      cartDrawer.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  cartTriggers.forEach(btn => btn.addEventListener('click', openCart));
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── FETCH CART ─────────────────────────────
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(err => console.error('Cart fetch error:', err));
  }

  function renderCart(cart) {
    const itemsContainer = document.querySelector('.cart-drawer__items');
    const totalEl = document.querySelector('.cart-total__price');

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `
        <div style="text-align:center; padding:60px 20px;">
          <p style="font-family:var(--font-display);font-style:italic;font-size:20px;color:rgba(252,252,252,0.4);">Your cart is empty</p>
          <a href="/collections/all" class="btn btn--outline-cream" style="margin-top:24px;display:inline-flex;">Explore Programmes</a>
        </div>`;
    } else {
      itemsContainer.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}" style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid rgba(195,167,111,0.12);">
          <img src="${item.image}" alt="${item.title}" style="width:70px;height:90px;object-fit:cover;background:var(--dark-3);">
          <div style="flex:1;">
            <p style="font-family:var(--font-heading);font-size:10px;font-weight:600;letter-spacing:0.15em;text-transform:uppercase;color:var(--white);margin-bottom:6px;">${item.title}</p>
            <p style="font-family:var(--font-display);font-size:20px;color:var(--gold);">${formatMoney(item.price)}</p>
            <div style="display:flex;align-items:center;gap:12px;margin-top:10px;">
              <button onclick="updateCartItem('${item.key}', ${item.quantity - 1})" style="background:none;border:1px solid rgba(195,167,111,0.35);color:var(--white);width:28px;height:28px;cursor:pointer;font-size:16px;">−</button>
              <span style="color:rgba(252,252,252,0.7);font-size:14px;">${item.quantity}</span>
              <button onclick="updateCartItem('${item.key}', ${item.quantity + 1})" style="background:none;border:1px solid rgba(195,167,111,0.35);color:var(--white);width:28px;height:28px;cursor:pointer;font-size:16px;">+</button>
            </div>
          </div>
          <button onclick="updateCartItem('${item.key}', 0)" style="background:none;border:none;color:rgba(252,252,252,0.3);cursor:pointer;font-size:20px;align-self:flex-start;padding:4px;">×</button>
        </div>`).join('');
    }

    if (totalEl) {
      totalEl.textContent = formatMoney(cart.total_price);
    }
  }

  window.updateCartItem = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => {
      renderCart(cart);
      updateCartCount(cart.item_count);
    });
  };

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    const badges = document.querySelectorAll('.cart-count');
    badges.forEach(b => {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ── ADD TO CART ────────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) {
        console.error('Add to cart: no data-variant-id set on this button.');
        return;
      }

      const originalHTML = this.innerHTML;
      this.innerHTML = '<span>Adding...</span>';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(async (r) => {
        const data = await r.json();
        if (!r.ok) {
          // Shopify returns { status, message, description } on error
          const msg = data.description || data.message || 'This item could not be added to the cart.';
          throw new Error(msg);
        }
        return data;
      })
      .then(() => {
        this.innerHTML = '<span>Added ✓</span>';
        setTimeout(() => {
          this.innerHTML = originalHTML;
          this.disabled = false;
          openCart();
        }, 800);
        return fetch('/cart.js').then(r => r.json());
      })
      .then(cart => updateCartCount(cart.item_count))
      .catch((err) => {
        console.error('Add to cart error:', err.message);
        this.innerHTML = '<span>Unavailable</span>';
        alert('Sorry, this item could not be added: ' + err.message + '\n\nVariant ID used: ' + variantId + '\n\nPlease check that this product is published to the Online Store sales channel and the variant ID is correct.');
        setTimeout(() => {
          this.innerHTML = originalHTML;
          this.disabled = false;
        }, 1500);
      });
    });
  });

  // ── CONTACT FORM ───────────────────────────
  const contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitBtn = this.querySelector('[type="submit"]');
      const successMsg = document.querySelector('.form-success');

      submitBtn.textContent = 'Sending...';
      submitBtn.disabled = true;

      // Shopify contact form submission
      const formData = new FormData(this);

      fetch('/contact', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(() => {
        this.style.display = 'none';
        if (successMsg) successMsg.style.display = 'block';
      })
      .catch(() => {
        submitBtn.textContent = 'Send Message';
        submitBtn.disabled = false;
      });
    });
  }

  // ── COUNTER ANIMATION ─────────────────────
  function animateCounter(el) {
    const target = parseInt(el.dataset.target || el.textContent, 10);
    if (isNaN(target)) return;
    const duration = 1600;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target) + (el.dataset.suffix || '');
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  if ('IntersectionObserver' in window) {
    const counterObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.querySelectorAll('[data-counter]').forEach(animateCounter);
          counterObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.trust-bar, .who-for__stat-badge').forEach(el => counterObs.observe(el));
  }

  // ── SMOOTH ANCHOR LINKS ───────────────────
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── PARALLAX HERO ─────────────────────────
  const heroBg = document.querySelector('.hero__bg img');
  if (heroBg && window.matchMedia('(min-width: 769px)').matches) {
    window.addEventListener('scroll', () => {
      const offset = window.scrollY * 0.3;
      heroBg.style.transform = `translateY(${offset}px)`;
    }, { passive: true });
  }

  // ── INIT CART COUNT ───────────────────────
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});
});
